import React from "react";

export default function Button({
  children,
  type = "button",
  className = "",
  clickHandler,
  ...props
}) {
  return (
    <button
      type={type}
      className={`inline-flex items-center text-[12px]/3 lg:text-[14px]/[16px] font-bold duration-300 cursor-pointer uppercase font-sans whitespace-nowrap px-4 pb-2 p ${className}`}
      onClick={clickHandler}
      {...props}
    >
      {children}
    </button>
  );
}
